import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ConfirmModal.css";

const ConfirmModal = ({ 
  isOpen, 
  title = "Confirm Action", 
  message = "Are you sure?", 
  confirmText = "Delete", 
  cancelText = "Cancel", 
  onConfirm, 
  onCancel, 
  variant = "danger" 
}) => {
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") onCancel();
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  // Rendered on <body>: most callers sit inside a scrolling pane, which clips a
  // nested dialog and keeps the backdrop from covering the app chrome.
  return createPortal(
    <div className="bc-confirm-overlay" onClick={onCancel}>
      <div className="bc-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`bc-confirm-icon bc-confirm-icon--${variant}`}>
          {variant === "danger" ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              <line x1="10" y1="11" x2="10" y2="17"/>
              <line x1="14" y1="11" x2="14" y2="17"/>
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          )}
        </div>
        <h3 className="bc-confirm-title">{title}</h3>
        <p className="bc-confirm-message">{message}</p>
        <div className="bc-confirm-actions">
          <button className="bc-confirm-btn bc-confirm-btn--cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button 
            ref={confirmBtnRef}
            className={`bc-confirm-btn bc-confirm-btn--${variant}`} 
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
